var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.pdfDialogVisible,
        center: "",
        title: "电子保单",
        width: "80%",
        top: "6vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.pdfDialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-row",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isDownLoading,
              expression: "isDownLoading",
            },
          ],
        },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    loading: _vm.isDownLoading,
                    size: "mini",
                    type: "primary",
                  },
                  on: { click: _vm.onDownloadAll },
                },
                [_vm._v("下载全部")]
              ),
              _vm.pdfDataList.length > 0
                ? _c(
                    "div",
                    _vm._l(_vm.pdfDataList, function (itemData, index) {
                      return _c(
                        "el-row",
                        { key: index, attrs: { type: "flex" } },
                        [
                          _c(
                            "el-col",
                            [
                              _c("el-row", [
                                _c("h3", [_vm._v(_vm._s(itemData.label))]),
                              ]),
                              _vm._l(itemData.value, function (item, indexNei) {
                                return _c(
                                  "el-row",
                                  {
                                    key: indexNei,
                                    attrs: { align: "middle", type: "flex" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "u-m-r-10" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "u-m-l-5",
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                _vm.download(
                                                  Object.assign(item, {
                                                    fileType: itemData.label,
                                                  })
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "u-font-weight-bold",
                                                style: item.isDownload
                                                  ? { color: "red" }
                                                  : { color: "gray" },
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(
                                                      item.isDownload
                                                        ? "已下载"
                                                        : "未下载"
                                                    ) +
                                                    "\n\t\t\t\t\t\t\t\t\t"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onCopy(
                                                  item.endorseNo ||
                                                    item.policyNo
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("复制单号")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-radio",
                                      {
                                        staticStyle: { "margin-top": "3px" },
                                        attrs: { label: item.url },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.handleViewPdf(
                                              item,
                                              itemData.label
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.file.url,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.file, "url", $$v)
                                          },
                                          expression: "file.url",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              item.endorseNo || item.policyNo
                                            ) +
                                            "\n\t\t\t\t\t\t\t"
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.getFileType === "pdf"
            ? _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-button-group",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            icon: "el-icon-arrow-left",
                            type: "primary",
                          },
                          on: { click: _vm.prevPdfPage },
                        },
                        [_vm._v("上一页")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.nextPdfPage },
                        },
                        [
                          _vm._v("\n\t\t\t\t\t下一页\n\t\t\t\t\t"),
                          _c("i", {
                            staticClass: "el-icon-arrow-right el-icon--right",
                          }),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.download()
                            },
                          },
                        },
                        [_vm._v("下载")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "10px", color: "#409eff" } },
                    [
                      _vm._v(
                        _vm._s(_vm.pageNum) + " / " + _vm._s(_vm.pageTotalNum)
                      ),
                    ]
                  ),
                  _c("pdf", {
                    attrs: { page: _vm.pageNum, src: _vm.pdfSrc },
                    on: {
                      progress: function ($event) {
                        _vm.loadedRatio = $event
                      },
                      "num-pages": function ($event) {
                        _vm.pageTotalNum = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.getFileType === "image"
            ? _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-button-group",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.download()
                            },
                          },
                        },
                        [_vm._v("下载")]
                      ),
                    ],
                    1
                  ),
                  _c("br"),
                  _c("viewer", {
                    ref: "viewer",
                    staticClass: "viewer",
                    attrs: { images: [_vm.file.url] },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._l(scope.images, function (src, index) {
                                return _c("img", {
                                  key: index,
                                  attrs: { src: src, alt: "", width: "100%" },
                                })
                              }),
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(scope.options) +
                                  "\n\t\t\t\t"
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3617327963
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }